module.exports = __webpack_public_path__ + "media/tips.c56a64cb.mp3";